<template>
  <div id="AgnetTracker" class="container admin-wrap mt-5">
    <div>
      <div class="row header mb-3">
        <div class="col-lg-5">
          <h3 class="text-left" v-if="!initSelectedValue">{{ ddlSelectedValue }}</h3>
          <h3 class="text-left" v-else>{{ lang('Agent ') }}{{ lang('Tracker') }}</h3>
        </div>
        <div class="col-lg-7">
          <!--<el-select v-on:change="loadList()" v-model="ddlSelectedValue"-->
          <!--placeholder="Please select:" filterable>-->
          <!--<el-option v-for="(items,i) in ddlSelection" :value="items.value" :key="i">{{items.text}}-->
          <!--</el-option>-->
          <!--</el-select>-->
          <el-tabs v-model="ddlSelectedValue" @tab-click="loadList()" v-if="!initSelectedValue">
            <el-tab-pane v-for="(items, i) in ddlSelection" :label="items.text" :name="items.value" :key="i"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="init-load" v-if="initSelectedValue">
        <button class="init-load_item" @click="initloadList('AgentList')">
          <img src="../assets/agenttracker-list.png" />
          {{ lang('Agent List') }}
        </button>
        <button class="init-load_item" @click="initloadList('AgentDetail')">
          <img src="../assets/agenttracker-agentdetail.png" />
          {{ lang('Agent Detail') }}
        </button>
        <button class="init-load_item" @click="initloadList('AgentCommission')">
          <img src="../assets/agenttracker-agenttracker.png" />
          {{ lang('Agent Commission') }}
        </button>
      </div>
      <!--alexis-->
      <div v-if="ddlInvoiceSelected">
        <invoice
          :propInvoiceListInt="InvoiceListInt"
          :propCurrentSchoolID="currentSchoolID"
          :propagentlistagentname="agentlistagentname"
          :propagentlistagentshortname="agentlistagentshortname"
          :propInvoiceListWithoutPayeeEmailInt="InvoiceListWithoutPayeeEmailInt"
          :propZipType="zipType"
          :propSpdSelection="spdSelection"
          @btnSaveAgent="btnSaveAgent"
          @btnVoidAgent="btnVoidAgent"
          @btnSendEmail="btnSendEmail"
          @btnSendEmailWithBreakdown="btnSendEmailWithBreakdown"
          @btnTestingSendEmail="btnTestingSendEmail"
          @btnTestingSendEmailWithBreakdown="btnTestingSendEmailWithBreakdown"
          ref="AgentList"
        />
      </div>
      <div v-if="ddlReceiptSelected">
        <receipt
          :propReceiptListInt="ReceiptListInt"
          :propCurrentSchoolID="currentSchoolID"
          :propReceiptListWithoutPayeeEmailInt="ReceiptListWithoutPayeeEmailInt"
          :propZipType="zipType"
          :propSpdSelection="spdSelection"
          @btnSaveAgentStudent="btnSaveAgentStudent"
          @btnSendEmail="btnSendEmail"
          @btnSendEmailWithBreakdown="btnSendEmailWithBreakdown"
          @btnTestingSendEmail="btnTestingSendEmail"
          @btnTestingSendEmailWithBreakdown="btnTestingSendEmailWithBreakdown"
          ref="AgentDetail"
        />
      </div>
      <div v-if="ddlCNSelected">
        <CN
          :propCNListInt="CNListInt"
          :propCurrentSchoolID="currentSchoolID"
          :propCNListWithoutPayeeEmailInt="CNListWithoutPayeeEmailInt"
          :propZipType="zipType"
          :propSpdSelection="spdSelection"
          @btnSaveAgentCommission="btnSaveAgentCommission"
          @btnSendEmail="btnSendEmail"
          @btnSendEmailWithBreakdown="btnSendEmailWithBreakdown"
          @btnTestingSendEmail="btnTestingSendEmail"
          @btnTestingSendEmailWithBreakdown="btnTestingSendEmailWithBreakdown"
          ref="AgentCommission"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import invoice from '../components/AgentTracker/AgentList'
import receipt from '../components/AgentTracker/AgentDetail'
import CN from '../components/AgentTracker/AgentCommission'
import { lang } from '../locale/index'
//import BModal from "../../node_modules_backup/bootstrap-vue/es/components/modal";
export default {
  name: 'InvoiceList',
  components: {
    // BModal
    invoice,
    receipt,
    CN,
  },
  async created() {
    // await this.Search();
    //await Cookies.get('schoolSession');
    //todo: for external auditor only
    let conType = Cookies.get('userTypeSession')
    if (conType === 'Auditor') {
      this.AuditDisabled = true
    }
    //todo: for external auditor only
  },
  async mounted() {
    Cookies.set('agentlistagentname', '', { expires: 3 / 24 })
    Cookies.set('agentlistagentshortname', '', { expires: 3 / 24 })
    Cookies.set('agentdetailagentname', '', { expires: 3 / 24 })
    Cookies.set('agentdetailstudentname', '', { expires: 3 / 24 })
    Cookies.set('agentcommissionagentname', '', { expires: 3 / 24 })
    Cookies.set('agentcommissionstudentname', '', { expires: 3 / 24 })

    this.currentSchoolID = await Cookies.get('schoolSession')

    /* this.agentlistagentname = await Cookies.get('agentlistagentname');
            if (this.agentlistagentname === "undefined")
            { this.agentlistagentname = "";  }

            alert('1');
            alert(this.agentlistagentname);

            this.agentlistagentshortname = await Cookies.get('agentlistagentshortname');
            if (this.agentlistagentshortname === "undefined")
            { this.agentlistagentshortname = "";  } */
  },
  data() {
    return {
      lang,
      currentSchoolID: '',
      zipType: '',

      agentlistagentname: '',
      agentlistagentshortname: '',

      ddlSelection: [
        { text: lang('AgentList'), value: 'AgentList', imgUrl: '<img src="../assets/agenttracker-list.png"/>' },
        { text: lang('AgentDetail'), value: 'AgentDetail', imgUrl: '../assets/agenttracker-agentdetail.png' },
        { text: lang('AgentCommission'), value: 'AgentCommission', imgUrl: '../assets/agenttracker-agenttracker.png' },
      ],
      ddlSelectedValue: [],
      ddlInvoiceSelected: false,
      ddlReceiptSelected: false,
      ddlCNSelected: false,
      ddlRefundSelected: false,
      initSelectedValue: true,
      spdSelection: [],
      // selectedEmailSenderListInt:[],
      startupText: '',
      //start: More detail
      studentCourseID: '',
      studentID: '',
      courseStatus: '',
      //End:More detail
      datePicker: {
        disabledDate(date) {
          return date < new Date().getTime() - 1 * 24 * 60 * 60 * 1000
          //  Without using the second variable, you can replace 7 for with your back x days:
          //  e.g return date< Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
        },
      },
      selectedData: [],

      // InvoiceListResp:[],
      InvoiceListInt: [],
      InvoiceListWithoutPayeeEmailInt: [],

      //receiptList:start
      ReceiptListInt: [],
      ReceiptListWithoutPayeeEmailInt: [],
      //receiptList:end

      //CNList:start
      //add new
      CNListAction: {
        label: lang('Info'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: '',
          },
        ],
      },
      CNListInt: [],
      CNList: [
        {
          prop: 'studentName',
          label: lang('Student') + lang('Name'),
        },
        {
          prop: 'Amount',
          label: lang('Amount'),
        },
        {
          prop: 'GstAmount',
          label: lang('Gst'),
        },
        {
          prop: 'TotalAmountIncGst',
          label: lang('TotalIncGst'),
        },
        {
          prop: 'OutstandingAmount',
          label: lang('Outstanding Amount'),
        },
        {
          prop: 'IH_Invoice_Status',
          label: lang('Invoice') + lang('Status'),
        },
        {
          prop: 'IH_Invoice_Name',
          label: lang('Invoice') + lang('NO'),
        },
        {
          prop: 'IH_Invoice_No',
          label: lang('CN') + lang('NO'),
        },
        {
          prop: 'IH_Invoice_Type',
          label: lang('Invoice') + lang('Type'),
        },
        {
          prop: 'email',
          label: lang('Payee') + lang('Email'),
        },
        {
          prop: 'sponsor_type',
          label: lang('Payee'),
        },
        {
          prop: 'fatherEmail',
          label: lang('Father') + lang('Email'),
        },
        {
          prop: 'motherEmail',
          label: lang('Mother') + lang('Email'),
        },
      ],

      CNListWithoutPayeeEmailInt: [],
      CNListWithoutPayeeEmail: [
        {
          prop: 'studentName',
          label: lang('Student') + lang('Name'),
        },
        {
          prop: 'IH_Invoice_Status',
          label: lang('Invoice') + lang('Status'),
        },
        {
          prop: 'IH_Invoice_No',
          label: lang('Invoice') + lang('Name'),
        },
        {
          prop: 'email',
          label: lang('Email'),
        },
        {
          prop: 'sponsor_type',
          label: lang('Payee'),
        },
      ],
      CNListWithoutPayeeEmailAction: {
        label: 'More info',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: 'More info',
          },
        ],
      },
      //CNList:end
      RefundListAction: {
        label: lang('Info'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: '',
          },
        ],
      },
      RefundListInt: [],
      RefundList: [
        {
          prop: 'studentName',
          label: lang('Student') + lang('Name'),
        },
        {
          prop: 'Amount',
          label: lang('Amount'),
        },
        {
          prop: 'GstAmount',
          label: lang('Gst'),
        },
        {
          prop: 'TotalAmountIncGst',
          label: lang('TotalIncGst'),
        },
        {
          prop: 'OutstandingAmount',
          label: lang('Outstanding Amount'),
        },
        {
          prop: 'IH_Invoice_Status',
          label: lang('Invoice') + lang('Status'),
        },
        {
          prop: 'IH_Invoice_Name',
          label: lang('Invoice') + lang('NO'),
        },
        {
          prop: 'IH_Invoice_No',
          label: lang('CN') + lang('NO'),
        },
        {
          prop: 'IH_Invoice_Type',
          label: lang('Invoice') + lang('Type'),
        },
        {
          prop: 'email',
          label: lang('Payee') + lang('Email'),
        },
        {
          prop: 'sponsor_type',
          label: lang('Payee'),
        },
        {
          prop: 'fatherEmail',
          label: lang('Father') + lang('Email'),
        },
        {
          prop: 'motherEmail',
          label: lang('Mother') + lang('Email'),
        },
      ],

      RefundListWithoutPayeeEmailInt: [],
      RefundListWithoutPayeeEmail: [
        {
          prop: 'studentName',
          label: lang('Student') + lang('Name'),
        },
        {
          prop: 'IH_Invoice_Status',
          label: lang('Invoice') + lang('Status'),
        },
        {
          prop: 'IH_Invoice_No',
          label: lang('Invoice') + lang('Name'),
        },
        {
          prop: 'email',
          label: lang('Email'),
        },
        {
          prop: 'sponsor_type',
          label: lang('Payee'),
        },
      ],
      RefundListWithoutPayeeEmailAction: {
        label: 'More info',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: 'More info',
          },
        ],
      },
      //RefundList:end

      AuditDisabled: false,
    }
  },
  methods: {
    async changeSelection(val) {
      this.spdSelection = val
    },
    initloadList(ddlSelectedValue) {
      this.ddlSelectedValue = ddlSelectedValue
      if (ddlSelectedValue === 'AgentList') {
        this.zipType = 'AgentList'
        this.ddlInvoiceSelected = true
        this.ddlReceiptSelected = false
        this.ddlCNSelected = false
        this.ddlRefundSelected = false
        this.initSelectedValue = false
      } else if (ddlSelectedValue === 'AgentDetail') {
        this.zipType = 'AgentDetail'
        this.ddlInvoiceSelected = false
        this.ddlReceiptSelected = true
        this.ddlCNSelected = false
        this.ddlRefundSelected = false
        this.initSelectedValue = false
      } else if (ddlSelectedValue === 'AgentCommission') {
        this.zipType = 'AgentCommission'
        this.ddlInvoiceSelected = false
        this.ddlReceiptSelected = false
        this.ddlCNSelected = true
        this.ddlRefundSelected = false
        this.initSelectedValue = false
      } else if (ddlSelectedValue === 'Refund') {
        this.zipType = 'cn'
        this.ddlInvoiceSelected = false
        this.ddlReceiptSelected = false
        this.ddlCNSelected = false
        this.ddlRefundSelected = true
        this.initSelectedValue = false
      }
    },
    loadList() {
      if (this.ddlSelectedValue === 'AgentList') {
        this.zipType = 'AgentList'
        this.ddlInvoiceSelected = true
        this.ddlReceiptSelected = false
        this.ddlCNSelected = false
        this.ddlRefundSelected = false
        this.initSelectedValue = false
      } else if (this.ddlSelectedValue === 'AgentDetail') {
        this.zipType = 'AgentDetail'
        this.ddlInvoiceSelected = false
        this.ddlReceiptSelected = true
        this.ddlCNSelected = false
        this.ddlRefundSelected = false
        this.initSelectedValue = false
      } else if (this.ddlSelectedValue === 'AgentCommission') {
        this.zipType = 'AgentCommission'
        this.ddlInvoiceSelected = false
        this.ddlReceiptSelected = false
        this.ddlCNSelected = true
        this.ddlRefundSelected = false
        this.initSelectedValue = false
      } else if (this.ddlSelectedValue === 'Refund') {
        this.zipType = 'refund'
        this.ddlInvoiceSelected = false
        this.ddlReceiptSelected = false
        this.ddlCNSelected = false
        this.ddlRefundSelected = true
        this.initSelectedValue = false
      }
    },
    async clearTablesList() {
      this.InvoiceListInt = []
      this.InvoiceListWithoutPayeeEmailInt = []
    },

    //alexis

    async btnSaveAgent(value, agentname, agentshortname, agentid, agentstatus, sendType) {
      try {
        //validate

        if (agentname == '' || agentshortname == '') {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Save blank Agent name or shortname',
          })
          return
        } else {
          let resp = {}
          const recresp = await DataSource.shared.saveNewAgent(agentname, agentshortname, agentid, agentstatus)
          resp = recresp

          if (resp.code == '2') {
            this.$notify.error({
              title: 'Message',
              message: 'Cannot Save Duplicate Agent',
            })
          } else if (resp.code == '3') {
            this.$notify.error({
              title: 'Message',
              message: 'Cannot Void Agent with Student Linked',
            })
          } else if (resp.code == '99') {
            this.$notify.error({
              title: 'Message',
              message: 'Cannot Save Agent',
            })
          } else {
            this.$notify({
              title: 'Success',
              message: 'Save Agent Success!',
              type: 'success',
            })
          }
        }
      } catch (e) {
        this.results = e
        this.$notify.error({
          title: 'Message',
          message: 'Cannot Save Agent :' + e.message,
        })
      }
    },

    async btnVoidAgent(value, agentid, sendType) {
      try {
        let resp = {}
        const recresp = await DataSource.shared.saveNewAgent('', '', agentid)
        resp = recresp

        if (resp.code == '2') {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Save Duplicate Agent',
          })
        } else if (resp.code == '3') {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Void Agent with Student Linked',
          })
        } else if (resp.code == '99') {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Void Agent',
          })
        } else {
          this.$notify({
            title: 'Success',
            message: 'Void Agent Success!',
            type: 'success',
          })
        }
      } catch (e) {
        this.results = e
        this.$notify.error({
          title: 'Message',
          message: 'Cannot Save Agent :' + e.message,
        })
      }
    },

    async btnSaveAgentStudent(value, editId, SchoolFee, Remarks, Status, AgentId, SchoolId, CourseId, StudentId, sendType) {
      try {
        let resp = {}
        const recresp = await DataSource.shared.saveAgentStudent(editId, SchoolFee, Remarks, Status, AgentId, SchoolId, CourseId, StudentId)
        resp = recresp

        if (resp.code == '2') {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Save Duplicate Agent',
          })
        } else if (resp.code == '99') {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Save Agent Student Info',
          })
        } else {
          this.$notify({
            title: 'Success',
            message: 'Save Agent Student School Fee Info!',
            type: 'success',
          })
        }
      } catch (e) {
        this.results = e
        this.$notify.error({
          title: 'Message',
          message: 'Cannot Save Agent Student Info :' + e.message,
        })
      }
    },

    async btnSaveAgentCommission(
      value,
      editId,
      receiptAmt,
      Commission,
      PaidAgentDate,
      InvoiceRefNo,
      Remarks,
      Status,
      agentid,
      studentid,
      receiptno,
      SemDetID,
      sendType,
    ) {
      try {
        let resp = {}
        const recresp = await DataSource.shared.saveAgentCommission(
          editId,
          receiptAmt,
          Commission,
          PaidAgentDate,
          InvoiceRefNo,
          Remarks,
          Status,
          agentid,
          studentid,
          receiptno,
          SemDetID,
        )
        resp = recresp

        if (resp.code == '2') {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Save Duplicate Agent',
          })
        } else if (resp.code == '99') {
          this.$notify.error({
            title: 'Message',
            message: 'Cannot Save Agent Commission Info',
          })
        } else {
          this.$notify({
            title: 'Success',
            message: 'Save Agent Commission Info!',
            type: 'success',
          })
        }
      } catch (e) {
        this.results = e
        this.$notify.error({
          title: 'Message',
          message: 'Cannot Save Agent Student Info :' + e.message,
        })
      }
    },

    async btnSendEmail(value, spdSelection, sendType) {
      try {
        if (value === 'No') {
          if (sendType === 'invoice') {
            this.$refs.invoice.hideModal()
          } else {
            this.$refs.receipt.hideModal()
          }
          // this.$refs.showBatchEmailConfirmationModal.hide();
        } else {
          this.spdSelection = spdSelection
          this.clearTablesList()
          let selectedObjList = []
          this.spdSelection.forEach(m => {
            let payeeEmails = m.email + ','

            if (m.motherEmail) {
              payeeEmails += m.motherEmail + ','
            }

            if (m.fatherEmail) {
              payeeEmails += m.fatherEmail + ','
            }

            payeeEmails = payeeEmails.substring(0, payeeEmails.length - 1)

            if (this.ddlSelectedValue === 'Receipt') {
              let list = {
                RH_Receipt_Name: m.RH_Receipt_Name,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: payeeEmails,
                RH_Receipt_No: m.RH_Receipt_Name,
                PK_Receipt_ID: m.PK_Receipt_ID,
              }
              selectedObjList.push(list)
            } else {
              let list = {
                IH_Invoice_No: m.IH_Invoice_No,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: payeeEmails,
              }
              selectedObjList.push(list)
            }
          })
          let resp = {}
          //todo:
          if (this.ddlSelectedValue === 'Receipt') {
            const recresp = await DataSource.shared.sendEmailReceipt(JSON.stringify(selectedObjList))
            resp = recresp
          } else {
            const invresp = await DataSource.shared.sendEmailInvoice(JSON.stringify(selectedObjList))
            resp = invresp
          }

          if (resp) {
            if (resp.code === '2') {
              this.$notify.error({
                title: 'Message',
                message: 'No Email Found',
              })
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Message',
                message: 'Cannot send email',
              })
            } else if (resp.code === '1') {
              this.$notify({
                title: 'Success',
                message: 'Send Success!',
                type: 'success',
              })
              // this.selectedEmailSenderListInt=resp.Table;
              // this.$refs.showBatchEmailConfirmationModal.hide();

              if (sendType === 'invoice') {
                this.$refs.invoice.hideModal()
              } else {
                this.$refs.receipt.hideModal()
              }
              // window.location.replace('/invoicelist');
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async btnSendEmailWithBreakdown(value, spdSelection, sendType) {
      try {
        if (value === 'No') {
          if (sendType === 'invoice') {
            this.$refs.invoice.hideModal()
          } else {
            this.$refs.receipt.hideModal()
          }
          // this.$refs.showBatchEmailConfirmationModalWithBreakdown.hide();
        } else {
          this.spdSelection = spdSelection
          this.clearTablesList()
          let selectedObjList = []
          this.spdSelection.forEach(m => {
            let payeeEmails = m.email + ','

            if (m.motherEmail) {
              payeeEmails += m.motherEmail + ','
            }

            if (m.fatherEmail) {
              payeeEmails += m.fatherEmail + ','
            }

            payeeEmails = payeeEmails.substring(0, payeeEmails.length - 1)

            if (this.ddlSelectedValue === 'Receipt') {
              let list = {
                RH_Receipt_Name: m.RH_Receipt_Name,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: payeeEmails,
                RH_Receipt_No: m.RH_Receipt_Name,
                PK_Receipt_ID: m.PK_Receipt_ID,
              }
              selectedObjList.push(list)
            } else {
              let list = {
                IH_Invoice_No: m.IH_Invoice_No,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: payeeEmails,
              }
              selectedObjList.push(list)
            }
          })

          var resp = {}
          //todo:
          if (this.ddlSelectedValue === 'Receipt') {
            const recresp = await DataSource.shared.sendBreakdownEmail(JSON.stringify(selectedObjList))
            resp = recresp
          } else {
            const invresp = await DataSource.shared.sendBreakdownEmail(JSON.stringify(selectedObjList))
            resp = invresp
          }

          if (resp) {
            if (resp.code === '2') {
              this.$notify.error({
                title: 'Message',
                message: 'No Email Found',
              })
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Message',
                message: 'Cannot send email',
              })
            } else if (resp.code === '1') {
              this.$notify({
                title: 'Success',
                message: 'Send Success!',
                type: 'success',
              })
              // this.selectedEmailSenderListInt=resp.Table;

              if (sendType === 'invoice') {
                this.$refs.invoice.hideModal()
              } else {
                this.$refs.receipt.hideModal()
              }
              // this.$refs.showBatchEmailConfirmationModalWithBreakdown.hide();
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async btnTestingSendEmail(value, spdSelection, sendType) {
      try {
        if (value === 'No') {
          if (sendType === 'invoice') {
            this.$refs.invoice.hideModal()
          } else if (sendType === 'refund') {
            this.$refs.refund.hideModal()
          } else {
            this.$refs.receipt.hideModal()
          }
        } else {
          this.spdSelection = spdSelection
          this.clearTablesList()
          let selectedObjList = []
          this.spdSelection.forEach(m => {
            let payeeEmails = m.email + ','

            if (payeeEmails !== m.fatherEmail && payeeEmails !== m.motherEmail) {
              payeeEmails += m.fatherEmail + ',' + m.motherEmail
              payeeEmails += ','
            } else {
              if (payeeEmails === m.fatherEmail && m.motherEmail !== '') {
                payeeEmails += m.motherEmail
                payeeEmails += ','
              }

              if (payeeEmails === m.motherEmail && m.fatherEmail !== '') {
                payeeEmails += m.fatherEmail
                payeeEmails += ','
              }
            }

            payeeEmails = payeeEmails.substring(0, payeeEmails.length - 1)

            if (this.ddlSelectedValue === 'Receipt') {
              let list = {
                RH_Receipt_Name: m.RH_Receipt_Name,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: m.newTestEmail,
                RH_Receipt_No: m.RH_Receipt_Name,
                PK_Receipt_ID: m.PK_Receipt_ID,
              }
              selectedObjList.push(list)
            } else {
              let list = {
                IH_Invoice_No: m.IH_Invoice_No,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: m.newTestEmail,
              }
              selectedObjList.push(list)
            }
          })

          var resp = {}
          //todo:
          if (this.ddlSelectedValue === 'Receipt') {
            const recresp = await DataSource.shared.sendEmailReceipt(JSON.stringify(selectedObjList))
            resp = recresp
          } else if (this.ddlSelectedValue === 'Refund') {
            const invresp = await DataSource.shared.sendEmailRefund(JSON.stringify(selectedObjList))
            resp = invresp
          } else {
            const invresp = await DataSource.shared.sendEmailInvoice(JSON.stringify(selectedObjList))
            resp = invresp
          }

          if (resp) {
            if (resp.code === '2') {
              this.$notify.error({
                title: 'Message',
                message: 'No Email Found',
              })
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Message',
                message: 'Cannot send email',
              })
            } else if (resp.code === '1') {
              this.$notify({
                title: 'Success',
                message: 'Send Success!',
                type: 'success',
              })

              if (sendType === 'invoice') {
                this.$refs.invoice.hideModal()
              } else {
                this.$refs.receipt.hideModal()
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async btnTestingSendEmailWithBreakdown(value, spdSelection, sendType) {
      try {
        if (value === 'No') {
          if (sendType === 'invoice') {
            this.$refs.invoice.hideModal()
          } else {
            this.$refs.receipt.hideModal()
          }
        } else {
          this.spdSelection = spdSelection
          let selectedObjList = []
          this.spdSelection.forEach(m => {
            let list = {
              IH_Invoice_No: m.IH_Invoice_No,
              studentID: m.FK_Student_ID,
              studentName: m.studentName,
              email: m.newTestEmail,
            }
            selectedObjList.push(list)
          })

          const resp = await DataSource.shared.sendBreakdownEmail(JSON.stringify(selectedObjList))
          if (resp) {
            if (resp.code === '2') {
              this.$notify.error({
                title: 'Message',
                message: 'No Email Found',
              })
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Message',
                message: 'Cannot send email',
              })
            } else if (resp.code === '1') {
              this.$notify({
                title: 'Success',
                message: 'Send Success!',
                type: 'success',
              })
              if (sendType === 'invoice') {
                this.$refs.invoice.hideModal()
              } else {
                this.$refs.receipt.hideModal()
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async sendRefundEmail(value, spdSelection, sendType) {
      console.log(value, spdSelection, sendType)
    },
    //Testing items only: end
  },
}
</script>
<style scoped>
.datatable-form__header .searchbtn {
  background: #4856ad;
  border-color: #4856ad;
  height: 37px;
  position: relative;
  top: 2px;
}

#invoice-list .header .el-select {
  margin-left: auto;
  display: table;
}

button.init-load_item img {
  width: 63px;
  display: block;
  margin: 0 auto 8px;
}

button.init-load_item {
  width: 150px;
  height: 150px;
  margin: 0 10px;
  border: 0;
  background: #007bff;
  color: white;
  padding: 20px 0;
  border-radius: 10px;
  cursor: pointer;
}

.init-load {
  /* display: flex; */
  padding: 20px 0;
}

button.init-load_item:hover {
  opacity: 0.8;
}

.invoiceList-search_item label {
  margin: 0;
}
</style>
<style>
.invoiceList-search_item {
  margin: 0 10px;
}

.invoiceList-search_item .el-date-editor {
  max-width: 220px;
  padding: 0 !important;
  margin: 0;
  border-color: #eee !important;
}

.invoiceList-search_item .el-date-editor i {
  display: none;
}

.invoiceList-search_item .el-date-editor .el-range-separator {
  width: 10px;
  padding: 0;
  display: table;
  position: relative;
  top: 4px;
}

.invoiceList-search_item .el-date-editor input {
  width: 100px;
  display: table;
}

.invoiceList-search_item input {
  height: 35px;
  border-color: #eee;
}

.invoiceList-search_wrap .datatable-form__header {
  border-bottom: 1px solid #edf0f4;
  padding-bottom: 20px;
  border-radius: 20px;
}
</style>
